import axios from 'axios'
import {_handleError,_handleSuccess,_getUrl,_getInvoiceProcessUrl} from './Handler.js'
import store from '../store/index'

export function _uploadFile(fileData){
    const config = { headers: {'Token': localStorage.getItem("user-token"), 'Content-Type': 'multipart/form-data' },};
    const url = `${_getInvoiceProcessUrl()}/invoiceProcess/fromFile`;
       let formData = new FormData();
    formData.append('file', fileData);

    return axios.post(url,fileData,config).then(_handleSuccess,_handleError)
} 
export function _searchInvoiceQueues(model){

    const config = {params:model, headers: {'Token': localStorage.getItem("user-token"), 'Content-Type': 'application/json' },};
    const url = `${_getInvoiceProcessUrl()}/invoiceProcess/queue/search`;
    return axios.get(url,config).then(_handleSuccess,_handleError)
}
export function _searchInvoiceRecords(model){

    const config = {params:model, headers: {'Token': localStorage.getItem("user-token"), 'Content-Type': 'application/json' },};
    const url = `${_getInvoiceProcessUrl()}/invoiceProcess/search`;
    return axios.get(url,config).then(_handleSuccess,_handleError)
} 
export function _searchInvoiceRecordsHistory(model){
    const config = {params:model, headers: {'Token': localStorage.getItem("user-token"), 'Content-Type': 'application/json' },};
    const url = `${_getInvoiceProcessUrl()}/invoiceProcess/history`;
    return axios.get(url,config).then(_handleSuccess,_handleError)
} 
export function _getProcessStatusEnumDescriptionStatus(){
    const config = { headers: {'Token': localStorage.getItem("user-token"), 'Content-Type': 'application/json' },};
    const url = `${_getInvoiceProcessUrl()}/invoiceProcess/processStatus`;
    return axios.get(url,config).then(_handleSuccess,_handleError)
} 
export function _getOperationStatusEnumDescriptionStatus(){
    const config = { headers: {'Token': localStorage.getItem("user-token"), 'Content-Type': 'application/json' },};
    const url = `${_getInvoiceProcessUrl()}/invoiceProcess/OperationStatus`;
    return axios.get(url,config).then(_handleSuccess,_handleError)
} 
export function _getDocumentTypeEnumDescriptionStatus(){
    const config = { headers: {'Token': localStorage.getItem("user-token"), 'Content-Type': 'application/json' },};
    const url = `${_getInvoiceProcessUrl()}/invoiceProcess/DocumentType`;
    return axios.get(url,config).then(_handleSuccess,_handleError)
} 